/**
 * 店鋪庫存管理系統常數定義
 * 進貨單相關 Enum 對應後端 Curves.Core.Enumeraction.Stock
 */

/** 店舖進貨單狀態 - 對應後端 ClubPurchaseReceiptStatusEnum */
export const CLUB_PURCHASE_RECEIPT_STATUS = Object.freeze({
	NONE: 0,
	WAITTINSPECTION: 1,   // 待驗收
	PARTIALINSPECTION: 2,  // 部分驗收
	COMPLETED: 5,          // 完成
	CANCELLED: 8,          // 已取消
	EXCEPTIONCLOSED: 9,    // 異常結單
});

/** 店舖進貨單貨源 - 對應後端 ClubSourceTypeEnum */
export const CLUB_SOURCE_TYPE = Object.freeze({
	NONE: 0,
	HEADQUARTERIMPORTED: 2,  // 總部
	CLUBTRANSFER: 3,         // 店舖調撥
	ALL: 99,                 // 全部
});

/** 店舖庫存單據類型 - 對應後端 ClubStockDocumentTypeEnum */
export const CLUB_STOCK_DOCUMENT_TYPE = Object.freeze({
	NONE: 0,       // 無
	RECEIPT: 1,    // 進貨單
	INSPECT: 2,    // 驗收單
	EXCEPTION: 3,  // 異常單
});

/** 店舖出貨類型 - 對應後端 ClubStockOutTypeEnum */
export const CLUB_STOCK_OUT_TYPE = Object.freeze({
	NONE: 0,                  // 無
	SALE: 1,                  // 銷售
	TRANSFER: 2,              // 調撥
	CONSUMPTION: 3,           // 一般領用
	RETURN: 4,                // 一般退貨
	DEFECTIVECONSUMPTION: 5,  // 瑕疵領用
	DEFECTIVERETURN: 6,       // 瑕疵退貨
	ALL: 99,                  // 全部
});

/** 店舖出貨單狀態 - 對應後端 ClubStockOutStatusEnum */
export const CLUB_STOCK_OUT_STATUS = Object.freeze({
	NONE: 0,   // 無
	NORMAL: 5, // 正常
	ERROR: 9,  // 異常
	ALL: 99,   // 全部
});

/** 店舖庫存異動類型（摘要卡篩選用）- 對應後端 RecordType */
export const INVENTORY_RECORD_TYPE = Object.freeze({
	INBOUND: 1,    // 入庫
	OUTBOUND: -1,  // 出庫
	ALL: 99,       // 全部
});

/** 店舖庫存異動紀錄來源類型 - 對應後端 ClubRecordReferenceTypeEnum */
export const CLUB_RECORD_REFERENCE_TYPE = Object.freeze({
	NONE: 0,                    // 無
	POSSALE: 1,                // 當日銷售
	TRANSFER: 2,               // 店舖調撥
	CONSUMPTION: 3,            // 商品領用
	RETURN: 4,                 // 一般退貨
	LOSS: 5,                   // 盤虧
	GAIN: 6,                   // 盤盈
	INSPECTION: 7,            // 入庫
	DEFECTIVEPROCESS: 8,      // 瑕疵回報
	DEFECTIVETRANSFERIN: 9,   // 瑕疵入庫
	DEFECTIVERETURN: 10,      // 瑕疵退貨
	ORDERCANCEL: 16,          // 訂單作廢
	ALL: 99,                   // 全部
});
